// frontend/src/components/HomeAIPreview.js
// ------------------------------------------------------------------
// Stand-alone preview component for the Home-page AI demo.
// Mirrors the layout of the in-dashboard PostPreview but does NOT
// touch that file.  Uses a realistic placeholder avatar.
// ------------------------------------------------------------------

import React from 'react'

const VIDEO_EXT = ['.mp4', '.mov', '.webm', '.avi', '.m4v']

export default function HomeAIPreview ({ caption, imgUrl = '' }) {
  const isVideo = (url = '') => VIDEO_EXT.some(e => url.toLowerCase().endsWith(e))

  const frame = { width: 300, height: 300 }     // square IG-feed preview
  const avatarUrl = '/assets/logo/icon-withbackground.png'  // realistic placeholder

  return (
    <div className='border bg-white rounded-4 shadow-sm' style={{ maxWidth: 400, margin: '0 auto' }}>
      {/* header */}
      <div className='d-flex align-items-center p-2'>
        <img
          src={avatarUrl}
          alt='avatar'
          className='rounded-circle'
          style={{ width: 40, height: 40, objectFit: 'cover' }}
        />
        <span className='ms-2 fw-bold'>GreatlySocial</span>
      </div>

      {/* main media */}
      {imgUrl ? (
        isVideo(imgUrl) ? (
          <video
            src={imgUrl}
            controls
            style={{ ...frame, objectFit: 'cover' }}
            className='d-block mx-auto'
          />
        ) : (
          <img
            src={imgUrl}
            alt='preview'
            style={{ ...frame, objectFit: 'cover' }}
            className='d-block mx-auto'
          />
        )
      ) : (
        <div
          className='bg-light d-flex align-items-center justify-content-center'
          style={{ ...frame, color: '#999', margin: '0 auto' }}
        >
          No media selected
        </div>
      )}

      {/* caption */}
      <div className='p-2'>
        {caption ? (
          <p className='mb-1' style={{ whiteSpace: 'pre-wrap' }}>
            <strong>GreatlySocial</strong> {caption}
          </p>
        ) : (
          <p className='text-muted mb-1'>Caption will appear here</p>
        )}
      </div>
    </div>
  )
}
